import { faEllipsis } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LegendChip as QueryRuleChip } from "core/components/LegendChip";
import Skeleton from "react-loading-skeleton";
import { QueryRow, QueryChildren, QueryGroupContainer } from "../styles";
import { MAX_CHIPS, OPERATOR_TEXT_MAPPING } from "../constants";
import Pill from "core/components/Pill";
import {
  faArrowsRotate,
  faCircleCheck,
  faCircleX,
} from "@fortawesome/pro-regular-svg-icons";
import { dh_colors } from "theme";

const getRightIcon = (intent) => {
  switch (intent) {
    case "positive":
      return faCircleCheck;

    case "negative":
      return faCircleX;

    case "modified":
      return faArrowsRotate;

    default:
      return "";
  }
};

export const Rule = ({ rule, showMoreItems, isGroup = false, isLast }) => {
  const icon = getRightIcon(rule.intent);

  if (rule.operator === "between" || rule.operator === "is not between") {
    return (
      <QueryRow className="queryRule">
        <QueryRuleChip
          text={`${rule.label}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip
          text={`${OPERATOR_TEXT_MAPPING[rule.operator]}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip
          text={`${rule.from}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip text="To" intent={rule.intent} rightIcon={icon} />
        <QueryRuleChip
          text={`${rule.to}`}
          intent={rule.intent}
          rightIcon={icon}
        />
      </QueryRow>
    );
  } else if (rule.operator === "is in" || rule.operator === "is not in") {
    const items = Array.isArray(rule.value)
      ? rule.value
      : rule.value.split(/\s*,\s*/);
    const hasMore = items.length > MAX_CHIPS;

    return (
      <QueryRow className="queryRule">
        <QueryRuleChip
          text={`${rule.label}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip
          text={`${OPERATOR_TEXT_MAPPING[rule.operator]}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip
          text={<>{items.slice(0, MAX_CHIPS).join(", ")}</>}
          intent={rule.intent}
          rightIcon={icon}
        />
        {hasMore && (
          <QueryRuleChip
            text={
              <>
                <FontAwesomeIcon
                  icon={faEllipsis}
                  onClick={() =>
                    showMoreItems(
                      rule.label,
                      items.map((item) => ({ label: item }))
                    )
                  }
                  style={{
                    color:
                      rule.intent === "unmodified"
                        ? dh_colors.black
                        : dh_colors.white,
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                />
              </>
            }
            intent={rule.intent}
          />
        )}
      </QueryRow>
    );
  } else if (rule.operator === "is null" || rule.operator === "is not null") {
    return (
      <QueryRow className="queryRule">
        <QueryRuleChip
          text={`${rule.label}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip
          text={`${OPERATOR_TEXT_MAPPING[rule.operator]}`}
          intent={rule.intent}
          rightIcon={icon}
        />
      </QueryRow>
    );
  } else {
    return (
      <QueryRow className="queryRule">
        <QueryRuleChip
          text={`${rule.label}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip
          text={`${OPERATOR_TEXT_MAPPING[rule.operator]}`}
          intent={rule.intent}
          rightIcon={icon}
        />
        <QueryRuleChip
          text={`${rule.value}`}
          intent={rule.intent}
          rightIcon={icon}
        />
      </QueryRow>
    );
  }
};

export const Group = ({ group, showMoreItems }) => (
  <QueryGroupContainer className="queryGroupContainer">
    <QueryRow className="queryGroup">
      <Pill
        text={
          group.operator.charAt(0).toUpperCase() + group.operator.slice(1) ||
          "And"
        }
        size="small"
        variant="operator"
        style={{ display: "inline" }}
      />
    </QueryRow>
    <QueryChildren className="queryChildren">
      <QueryItems
        items={group.filters}
        showMoreItems={showMoreItems}
        isGroup={true}
      />
    </QueryChildren>
  </QueryGroupContainer>
);

export const QueryItems = ({ items, showMoreItems, isGroup = false }) => (
  <>
    {items?.map((item, index) => (
      <QueryItem
        key={index}
        item={item}
        showMoreItems={showMoreItems}
        isGroup={isGroup}
        isLast={index === items.length - 1}
      />
    ))}
  </>
);

export const QueryItem = ({ item, showMoreItems, isGroup, isLast }) =>
  item.filters ? (
    <Group group={item} showMoreItems={showMoreItems} />
  ) : (
    <Rule
      rule={item}
      showMoreItems={showMoreItems}
      isGroup={isGroup}
      isLast={isLast}
    />
  );

export const SkeletonAccordion = ({ itemCount = 1 }) => {
  return (
    <Skeleton
      count={itemCount}
      style={{
        height: "58px",
        padding: "15px 20px",
        marginBottom: "10px",
        borderRadius: "5px",
      }}
    />
  );
};
